<template>
  <div class="index_background" style="padding: 20px">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <h5 align="center">重置密码</h5>
      <el-form-item label="登录账号" prop="mobile">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="vcode">
        <!-- <el-input type="vcode" v-model="ruleForm.vcode" autocomplete="off"></el-input>
        <a class="sendCode" @click="sendCode()" style="color:blue">发送验证码到邮箱</a> -->
        <el-input class="vcode" type="vcode" maxlength="6" suffix-icon="el-icon-lock" placeholder="验证码" v-model="ruleForm.vcode" />
        <el-button class="vcode-button" type="info" plain :disabled="disabled" @click="sendCode">{{ valiBtn }}</el-button>
      </el-form-item>

      <el-form-item>
        <!-- <el-button type="primary" @click="sendCode('ruleForm')">发送验证码到邮箱</el-button> -->
        <el-button type="primary" @click="submitForm('ruleForm')">重置密码</el-button>
        <el-button type="info" @click="toLogin">去登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { resetPwdApi } from '@/api/getData.js'
import { sendEmailCodeApi } from '@/api/getData.js'
export default {
  data() {
    return {
      ruleForm: {
        mobile: '',
        vcode: '',
        verKey: ''
      },
      valiBtn: '获取验证码',
      disabled: false,
      rules: {
        mobile: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 6, max: 11, message: '长度6-11个字符', trigger: 'blur' }
        ],
        vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loading: false,
      toEmail: ''
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          //调用重置密码接口
          resetPwdApi(this.ruleForm).then(res => {
            res = res.data
            if (res.code == 0) {
              this.open(res.msg)
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
            this.loading = false
          })
        } else {
          this.$message({
            type: 'warning',
            message: '填写信息有误，请检查!'
          })
          return false
        }
      })
    },
    open(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
          this.$message({
            type: 'info',
            message: `action: ${action}`
          })
        }
      })
    },
    sendCode() {
      //调用发送验证码接口
      sendEmailCodeApi(this.ruleForm.mobile).then(res => {
        res = res.data
        this.ruleForm.verKey = res.data
        if (res.code == 0) {
          this.tackBtn() //验证码倒数60秒
          this.$message({
            type: 'success',
            message: '发送成功!' + res.message
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
      })
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer)
          this.valiBtn = '获取验证码'
          this.disabled = false
        } else {
          this.disabled = true
          this.valiBtn = time + '秒后重试'
          time--
        }
      }, 1000)
    },

    toLogin() {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
// body {
//   background: url('../../assets/images/background.jpg') center top no-repeat;
// }
.el-form {
  // width: 420px;
  // margin: auto;
  // padding: 45px;
  // height: 550px;
  // background-color: #fff;
  // margin-left: 1000px;
  // margin-top: 50px;
  // border-radius: 15px;

  position: absolute;
  width: 420px;
  height: 550px;
  padding: 45px;
  top: 10%;
  right: 5%;
  background-color: #fff;
  border-radius: 15px;
}

.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 50px;
  padding: 10px 12px 0 0;

  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
h5 {
  font-size: max($numbers: 25px);
  padding-bottom: 50px;
}
.index_background {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/images/background1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}
.sendCode {
  cursor: pointer;
}
.btn-orange {
  background-color: rgb(154, 192, 228);
  //width: 40px;
}
</style>
<style>
.vcode {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: 65%;
}
.vcode-button {
  width: 35%;
  padding-left: 5px;
}
</style>
